import Vue from "vue";
import VueRouter from "vue-router";
import Splash from "../views/Splash.vue";

Vue.use(VueRouter);

const routes = [
  // mode:'history',
  {
    path: "/",
    name: "Splash",
    component: Splash,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/create-ad",
    name: "CreateAd",
    component: () => import("../views/CreateAd.vue"),
  },

  {
    path: "/pincode",
    name: "pincode",
    component: () => import("../views/Pincode.vue"),
  },

  {
    path: "/ad-details",
    name: "AdDetails",
    component: () => import("../views/AdDetails.vue"),
  },
  {
    path: "/create-ad-form",
    name: "CreateAdForm",
    component: () => import("../views/CreateAdForm.vue"),
  },
  {
    path: "/order-status",
    name: "OrderSuccess",
    component: () => import("../components/OrderSuccess"),
  },
];

const router = new VueRouter({
  mode: "",
  base: process.env.BASE_URL,
  routes,
});

export default router;
